export default function (state,getters) {
    let form = getters.data;
    let url = '';
    for (let k in form) {
        switch (k){
            case 'IssueDateFrom':
            case 'IssueDateTo':
            case 'StartDateFrom':
            case 'StartDateTo':
            case 'EndDateFrom':
            case 'EndDateTo':
            case 'CreateDateFrom':
            case 'CreateDateTo':
                url += '&' + encodeURIComponent('parameters[' + k + '.Serialized]') + '=' + encodeURIComponent(form[k].Serialized);
                break;
            default:
                url += '&' + encodeURIComponent('parameters[' + k + ']') + '=' + encodeURIComponent(form[k]);
        }
    }
    return url;
}